import React from "react";
import CustomSelectBox from "../../../components/ReactSelect/ReactSelect";
import { SelectOptions } from "../../../utils/constants";
import styles from "../Membership.module.css";
const customStyleProps = {
  width: "100%", // ✅ forces Select box to fill parent container
  borderRadius: "10px",
  border: "1px solid #AEAEAE",
  padding: "2px 6px",
  boxShadow: "none",
  "&:hover": {
    border: "1px solid #AEAEAE",
  },
  arrowColor: "#7B7B7B",
  showPipe: false,
};

export default function KnowledgehubProgram() {
  return (
    <section className={styles.KnowledgehubProgram}>
      <div className={styles.container}>
        <h3>
          Knowledge Hub <span>Program</span>
        </h3>
        <div className={styles.programBox}>
          <div className={styles.left}>
            <div className={styles.criteria}>
              <h4>Eligibility Criteria</h4>
              <ul>
                <li>Established research institution</li>
                <li>Minimum 100 active researchers</li>
                <li>Strong publication record</li>
                <li>International collaboration experience</li>
              </ul>
            </div>
            <div className={`${styles.criteria} ${styles.rating}`}>
              <h4>Benefits</h4>
              <ul>
                <li>Established research institution</li>
                <li>Minimum 100 active researchers</li>
                <li>Strong publication record</li>
                <li>International collaboration experience</li>
              </ul>
            </div>
          </div>
          <div className={styles.formBoxProgramHub}>
            <h4>Knowledge Hub Program</h4>
            <form>
              <div className={styles.formRow}>
                <input
                  type="text"
                  placeholder="Institution Name"
                  className={styles.input}
                />
                <input
                  type="email"
                  placeholder="Email Address"
                  className={styles.input}
                />
              </div>
              <div className={styles.formRow}>
                <div style={{ width: "100%" }}>
                  <CustomSelectBox
                    options={SelectOptions}
                    customStyleProps={customStyleProps}
                  />
                </div>
              </div>
              <div className={styles.formRow}>
                <textarea
                  placeholder="Tell us about your institution..."
                  className={styles.textarea}
                ></textarea>
              </div>
              <div className={styles.formRow}>
                <button type="submit" className={styles.primaryBtn}>
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
